import ImportWithRule from './src/import-with-rule';

export default ImportWithRule;
